import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Toolbar from "../components/Toolbar";
import ToolbarOption from '../components/ToolbarOption';
import { isEmpty } from '../helpers';

import { Input } from '@progress/kendo-react-inputs';
import { GridColumn as Column } from '@progress/kendo-react-grid';
import { BlankCell } from '../components/utils/GridHelpers';


import { deepClone } from '../helpers';

import { AppContext } from '../context/AppContext';
import isPage from '../hoc/isPage';

import GridContainer from '../components/GridContainer';

class OrgGroupSetDataPage extends Component {

    static propTypes = {
        reportGroupID: PropTypes.string,
        handleCloseModal: PropTypes.func,
        handleRefreshListing: PropTypes.func
    }

    lastSelectedIndex = 0;

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    get initialState() {
        return {
            childDealerships: [],
            reportGroup: {}, // data for the currently selected report group
            isReportGroupCreated: false
        }
    }


    componentDidMount() {

        // ensure that we have a list of child dealerships
        if (isEmpty(this.context.state.childDealerships)) {

            // do the API call
            this.props.getData("/api/portal/dealer/GetList").then((response) => {

                this.context.setState({ childDealerships: response.data });

                this.getReportGroupData();
            });
        } else {

            this.getReportGroupData();
        }
    }

    getReportGroupData = () => {

        // take a copy of the child dealerships

        this.setState({
            childDealerships: deepClone(this.context.state.childDealerships)
        }, () => {

            // now let's get a copy of the report groups
            const reportGroupID = this.props.reportGroupID;



            if (reportGroupID) {
                this.props.getData(`/api/portal/reportGroup/${reportGroupID}/GetReportGroup`).then(response => {



                    this.setState({ reportGroup: response.data });

                    // get child dealerships

                    let childDealerships = this.state.childDealerships;

                    // mark as selected those dealerships that are part of this report group

                    childDealerships.forEach(dealer => {
                        // for each dealership, check if its storeNumber exists in this.props.data.reportGroupOrgs.storeNumber

                        // check if this dealership is part of the list
                        if (response.data.reportGroupOrgs.findIndex(reportGroupOrg => reportGroupOrg.storeNumber === dealer.storeNumber) >= 0) {
                            dealer.selected = true;
                        }
                    });


                    this.setState({
                        childDealerships: childDealerships
                    });
                });
            }
        });
    }



    selectionChange = (event) => {

        event.dataItem.selected = !event.dataItem.selected;
        this.forceUpdate();
    }

    rowClick = (event) => {

        let last = this.lastSelectedIndex;
        const childDealerships = this.state.childDealerships;
        const current = childDealerships.findIndex(dataItem => dataItem === event.dataItem);

        if (!event.nativeEvent.shiftKey) {
            this.lastSelectedIndex = last = current;
        }

        const select = !event.dataItem.selected;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {

            childDealerships[i].selected = select;
        }
        this.setState({
            childDealerships: childDealerships
        });
        this.forceUpdate();
    }

    headerSelectionChange = (event) => {

        const checked = event.syntheticEvent.target.checked;
        this.state.childDealerships.forEach(item => item.selected = checked);
        this.forceUpdate();
    }
    handleSubmit = (e) => {

        // get the selected org group items
        const hasOneSelectedDealer = (this.state.childDealerships.findIndex((item) => item.selected) >= 0);

        // get report group name
        const reportGroupName = this.state.reportGroup.reportGroupName;

        let errorMessage = "";

        if (!reportGroupName || reportGroupName.length === 0) {
            errorMessage = this.props.returnLocalizedString("m0240");
        } else if (!hasOneSelectedDealer) {
            errorMessage = this.props.returnLocalizedString("m0241");
        }

        if (errorMessage.length > 0) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), errorMessage);
            return;
        }



        let orgIDs = [];

        // get a list of selected dealers
        this.state.childDealerships.forEach(dealer => {
            if (dealer.selected) {
                orgIDs.push(dealer.orgID);
            }
        });



        const reportGroup = {
            "reportGroupName": reportGroupName,
            "orgIDs": orgIDs
        };


        if (this.props.reportGroupID) {
            reportGroup.reportGroupID = this.props.reportGroupID;
        }

        const operation = ((this.props.reportGroupID) ? "m0032" : "m0033");



        // pull the trigger on the API

        this.props.postData("/api/portal/reportGroup/SetReportGroup", reportGroup).then(response => {



            this.props.alert("success", this.props.returnLocalizedString("m0036"), this.props.returnLocalizedString("m0242", operation));

            // Hide the save button
            this.setState({
                isReportGroupCreated: true
            });

            // refresh the master list of report groups
            this.props.handleRefreshListing();

            // if we just created a new report group, then close the modal
            if (!this.props.reportGroupID) {
                this.props.handleCloseModal();
            }

        }).catch(error => {


            this.props.alert("error", this.props.returnLocalizedString("m0023"), error.response.data);

        });
    }

    handleChange = (e) => {
        const reportGroup = {
            ...this.state.reportGroup,
            [e.target.name]: e.target.value
        }
        this.setState({
            reportGroup: reportGroup
        });
    }

    render() {

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0032@ updated !DEVNOTE! Action status
        //!DBTRANS! @m0033@ created !DEVNOTE! Action status
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status reason
        //!DBTRANS! @m0240@ You must specify a name for this group. !DEVNOTE! Action status reason
        //!DBTRANS! @m0241@ You must include at least one dealership in this group. !DEVNOTE! Action status reason
        //!DBTRANS! @m0242@ The organization group was successfully %action%! !DEVNOTE! Action status
        //!DBTRANS! @m0243@ Create Report Group !DEVNOTE! Button label
        //!DBTRANS! @m0244@ Modify Report Group !DEVNOTE! Button label
        //!DBTRANS! @m0245@ Enter group name and select stores for this group. !DEVNOTE! Input field label
        //!DBTRANS! @m0246@ Select stores for this group. !DEVNOTE! Input field label
        //!DBTRANS! @m0247@ Report Group Name: !DEVNOTE! Input field label
        //!DBTRANS! @m0248@ Store Number !DEVNOTE! Input field label
        //!DBTRANS! @m0249@ Organization Name !DEVNOTE! Input field label

        return (
            <React.Fragment>
                <div className='position-relative'>
                    <div className="k-window-title k-dialog-title ">
                        {isEmpty(this.props.reportGroupID) ? this.props.returnLocalizedString("m0243") : this.props.returnLocalizedString("m0244")}
                    </div>
                    <Toolbar onEditScrtooltip={true} >
                        {/* If successfully created a group, then hide the Save button */}
                        <ToolbarOption onEditScrtooltip={true} type="save" handleClick={this.handleSubmit} />

                        <ToolbarOption onEditScrtooltip={true} type="close" handleClick={this.props.handleCloseModal} />
                    </Toolbar>

                    {
                        (isEmpty(this.props.reportGroupID) ?
                            (<p className="top-margin-20 bottom-margin-20">{this.props.returnLocalizedString("m0245")}</p>) :
                            (<p className="top-margin-20 bottom-margin-20">{this.props.returnLocalizedString("m0246")}</p>)
                        )
                    }

                    <div className="bottom-margin-10">
                        <label htmlFor="reportGroupName">{this.props.returnLocalizedString("m0247")}</label>
                        <Input required={true} value={this.state.reportGroup.reportGroupName} id="reportGroupName" name="reportGroupName" onChange={this.handleChange} />
                    </div>

                    <section className="grid-container">

                        <GridContainer
                            data={this.state.childDealerships}
                            selectedField="selected"
                            onSelectionChange={this.selectionChange}
                            onHeaderSelectionChange={this.headerSelectionChange}
                            onRowClick={this.rowClick}
                            filterable
                            sortColumn="storeNumber"
                        >
                            <Column
                                filterable={false}
                                field="selected"
                                width="50px"
                            />
                            <Column field="storeNumber" title={this.props.returnLocalizedString("m0248")} width="200px" />
                            <Column field="orgName" title={this.props.returnLocalizedString("m0249")} width="300px" />
                            <Column
                                filterable={false}
                                cell={(props) => (
                                    <BlankCell {...props} />
                                )}
                            />
                        </GridContainer>

                    </section>



                </div>
            </React.Fragment>
        );
    }
}

export default isPage(OrgGroupSetDataPage);
OrgGroupSetDataPage.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/OrgGroupSetDataPage.js